module.exports = __webpack_public_path__ + "img/Other3.f563247c.svg";